import { darken, lighten } from '@mui/material';
import { palette } from '../palette';
import lightOrdarkColor from "@check-light-or-dark/color";

const MuiTooltip = {
  styleOverrides: {
    tooltip: ({theme} : any)=>({
      borderRadius: '4px',
      backgroundColor: lightOrdarkColor(theme.palette.background.default) === 'dark' ?  lighten(theme.palette.background.default,0.2)  :  darken(theme.palette.background.default,0.7) ,//theme.palette.text.primary,
      color:  theme.palette.text.contrastText
    }),
    arrow:({theme} : any)=>({
      height: '8px',
      width: '14px',
      color: lightOrdarkColor(theme.palette.background.default) === 'dark' ?  lighten(theme.palette.background.default,0.2)  :  darken(theme.palette.background.default,0.7)
    }),
  },
};

export default MuiTooltip;

